<h2 mat-dialog-title>{{'Reset Password' | translate}}</h2>
<mat-dialog-content>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
        <div class="form-container">
            <mat-form-field class="mb-25">
                <mat-label>{{'Password' | translate}}</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                    [errorStateMatcher]="matcher" />
                <button mat-icon-button type="button" matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <span class="material-symbols-outlined">
                        {{ hidePassword ? "visibility_off" : "visibility" }}
                    </span>
                </button>
                <mat-error *ngIf="
                        resetPasswordForm
                            .get('password')
                            ?.hasError('passwordStrength')
                    ">
                    {{'Password must have' | translate}}:
                    <span *ngIf="!resetPasswordForm.get('password')?.errors?.['passwordStrength']?.hasMin8Chars">
                        {{'At least 8 characters' | translate}},
                    </span>
                    <span *ngIf="!resetPasswordForm.get('password')?.errors?.['passwordStrength']?.hasUpperChar">
                        {{'An uppercase letter' | translate}},
                    </span>
                    <span *ngIf="!resetPasswordForm.get('password')?.errors?.['passwordStrength']?.hasLowerChar">
                        {{'A lowercase letter' | translate}},
                    </span>
                    <span *ngIf="!resetPasswordForm.get('password')?.errors?.['passwordStrength']?.hasNumber">
                        {{'A number' | translate}}.
                    </span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'Confirm_password' | translate}}</mat-label>
                <input matInput [type]="hidePasswordConfirm ? 'password' : 'text'" formControlName="confirmPassword" />
                <button mat-icon-button type="button" matSuffix (click)="hidePasswordConfirm = !hidePasswordConfirm"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePasswordConfirm">
                    <span class="material-symbols-outlined">
                        {{
                        hidePasswordConfirm
                        ? "visibility_off"
                        : "visibility"
                        }}
                    </span>
                </button>
                <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.invalid">
                    {{ 'Passwords do not match' | translate }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="button-container">
            <button mat-raised-button class="daxa" type="submit" [disabled]="resetPasswordForm.invalid || isLoading">
                {{isLoading? 'Loading' : ('Save' | translate)}}
            </button>
            <button mat-raised-button color="warn" mat-dialog-close>
                {{ 'Cancel' | translate }}
            </button>
        </div>
    </form>
    <div class="alert alert-bg-danger d-flex justify-content-between align-items-center" role="alert"
        *ngIf="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="alert alert-bg-success d-flex justify-content-between align-items-center" role="alert"
        *ngIf="successAlert">
        {{ 'Password updated successfully' | translate }}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
</mat-dialog-content>